"use strict";
// _recruit-filter.js — 募集要項一覧の職種・勤務地フィルター

{
  jQuery(function ($) {
    const $lists = $(".p-lowerRecruitArchive__filterList");
    if (!$lists.length) return;

    // グループごとの選択状態（初期はすべて）
    const state = { job: "all", location: "all" };

    function applyFilter() {
      $(".p-lowerRecruitArchive__card").each(function () {
        const $card = $(this);
        const job = String($card.attr("data-job") || "");
        const locations = String($card.attr("data-location") || "").split(" ");
        const jobOk = state.job === "all" || job === state.job;
        const locOk = state.location === "all" || locations.indexOf(state.location) !== -1;
        $card.toggle(jobOk && locOk);
      });
    }

    $(".p-lowerRecruitArchive__filterBtn").on("click", function () {
      const $btn = $(this);
      const $list = $btn.closest(".p-lowerRecruitArchive__filterList");
      const group = $list.attr("data-filter-group");
      if (!group) return;

      state[group] = $btn.attr("data-filter");
      $list.find(".p-lowerRecruitArchive__filterBtn").removeClass("is-active");
      $btn.addClass("is-active");
      applyFilter();
    });
  });
}
